import { render, staticRenderFns } from "./StudentPasswordReset.vue?vue&type=template&id=6837dcc0"
import script from "./StudentPasswordReset.vue?vue&type=script&lang=js"
export * from "./StudentPasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports